export const getters = {
  getSubscriptionBrandingColor (state) {
    return state?.subscriptionBranding?.color
  },
  hasDataroomStoragePlan (state) {
    return state?.subscription?.dataroomAccessType === 'PLAN'
  },
  hasSubscriptionEnvelopesPacks (state) {
    return state?.subscription?.hasEnvelopesPacks
  },
}
